import { ThrowableStatus } from "@wss/error-tracking/throwable";
import { CarouselItem } from "../Carousel/CarouselItem";

type RecommendationItemsResponse = {
  items: CarouselItem[];
  event: string;
  eventLabel: string;
};

const fetchRecommendationCarouselItems = async (
  itemNumber: string,
  title: string,
  excludedItemNumbers: string[],
  modelName: string,
): Promise<ThrowableStatus<RecommendationItemsResponse>> => {
  const params = new URLSearchParams(window.location.search);
  const productIsHidden = params.get("showhidden");
  if (productIsHidden) {
    return { isError: false, value: { items: [], event: "", eventLabel: "" } };
  }

  try {
    const response = await fetch("/api/recommendationitems", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        itemNumber,
        title,
        excludedItemNumbers,
        modelName,
      }),
    });

    if (!response.ok) {
      return {
        isError: true,
        status: response.status,
        error: new Error(response.statusText),
      };
    }
    const result = await response.json<RecommendationItemsResponse>();
    return { isError: false, value: result };
  } catch (error) {
    return {
      isError: true,
      status: null,
      error: new Error(
        "There was an error with the '/api/recommendationitems' endpoint",
        { cause: error },
      ),
    };
  }
};

export default fetchRecommendationCarouselItems;
